










































import Vue from 'vue';

import _ from 'lodash';

import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import emailPreferenceForm from '@/components/molecules/emailPreferenceForm.vue';
import emailPreferenceReasonForm from '@/components/molecules/emailPreferenceReasonForm.vue';
import successEmailPreference from '@/components/molecules/successEmailPreference.vue';
import customerPreference from '@/store/modules/customerPreference';

import { getCustPreference } from '@/store/models.d';

// COMPONENTS
@Component({
  components: {
    'email-preference-form': emailPreferenceForm,
    'email-preference-reason-form': emailPreferenceReasonForm,
    successEmailPreference,
  },
})
export default class EmailPreferences extends Vue { // eslint-disable-next-line
  // WATCH
  @Watch('$route', { immediate: true, deep: true }) // eslint-disable-next-line
  routeChanged(to: any): void {
    this.customerID = to.query.customerId;
    document.title = to.meta.title || 'Email Preference Page';
  }

  get customerPreference() {
    return this.$store.state.customerPreference || {};
  }

  async created() {
    const customerPreferenceQuery: getCustPreference | any = {
      campaignId: this.$route.query.campaignId,
      token: this.$route.query.token,
    };

    if (this.$route.name !== 'error') {
      await customerPreference.check(customerPreferenceQuery);

      if (_.isEmpty(this.customerPreference.customerPreference) || this.customerPreference.customerPreference.status === 'error') {
        this.$router.push({
          path: '/error',
          name: 'error',
          params: { message: 'Page not found. Please try again later.' },
        });
      }

      this.loadings.page = false;

      switch (!_.isEmpty(this.customerPreference.customerPreference)) {
        case false:
          this.$router.push({
            path: '/error',
            name: 'error',
            params: { message: this.customerPreference.customerPreference.message },
          });
          break;
        case true:
          this.selected = this.customerPreference.customerPreference.email.campaign.value || '';
          break;

        default:
          break;
      }
    }
  }

  // DATAS
  customerID = '';

  selected = '';

  checkedList = {};

  toggle = {
    emailPreferenceForm: true,
    emailPreferenceReasonForm: false,
    success: false,
  }

  loadings = {
    page: true,
    button: false,
    reason: false,
  }

  public async emailPreferenceFormClick(selected: any): Promise<any> {
    this.loadings.button = true;
    this.selected = selected;

    const params: any = {
      value: this.selected,
      checkedList: [],
    };

    switch (this.selected === 'UNSUBSCRIBE') {
      case true:
        this.toggle.emailPreferenceReasonForm = true;
        break;
      case false:
        await customerPreference.update({
          campaignId: this.$route.query.campaignId,
          merchantId: this.$route.query.merchantId,
          token: this.$route.query.token,
          params,
        });

        this.toggle.success = true;
        break;

      default:
        break;
    }

    this.toggle.emailPreferenceForm = false;
    this.loadings.button = false;
  }

  public async emailPreferenceReasonClick(checkedList: any): Promise<any> {
    this.loadings.reason = true;

    const params: any = {
      value: this.selected,
      checkedList,
    };

    await customerPreference.update({
      campaignId: this.$route.query.campaignId,
      token: this.$route.query.token,
      merchantId: this.$route.query.merchantId,
      params,
    });

    if (this.customerPreference.updatePreference.updateStatus >= 200
      && this.customerPreference.updatePreference.updateStatus <= 200) {
      this.toggle.emailPreferenceReasonForm = false;
      this.toggle.success = true;
    }

    this.loadings.button = false;
  }
}
